import {Information} from './Information'
import {ContentsForPagination} from '../../components/shared/ContentsForPagination'

export class ApiResponse<T> {
    details: T
    informations: Information[]

    constructor(
        details: T,
        informations: Information[],
    ) {
        this.details = details
        this.informations = informations
    }

    static from<K>(json: any, fromDetails?: (details: any) => K): ApiResponse<K> {
        const apiResponse: ApiResponse<K> = json
        return new ApiResponse(
            fromDetails == null ? {} as K :
                fromDetails(apiResponse.details),
            ApiResponse.formatInformations(apiResponse.informations),
        )
    }

    static fromArray<L>(json: any, fromDetails?: (details: any) => L): ApiResponse<L[]> {
        const apiResponse: ApiResponse<L[]> = json
        return new ApiResponse(
            (fromDetails == null || apiResponse.details == null) ? [] :
                apiResponse.details.map(detail => fromDetails(detail)),
            ApiResponse.formatInformations(apiResponse.informations),
        )
    }

    static fromContentsForPagination<M>(json: any, fromDetails: (details: any) => M)
        : ApiResponse<ContentsForPagination<M>> {
        const apiResponse: ApiResponse<ContentsForPagination<M>> = json
        const contents: M[] = apiResponse.details.contents.map(
            content => fromDetails(content),
        )
        return new ApiResponse(
            new ContentsForPagination<M>(
                apiResponse.details.totalContentsCount,
                contents,
            ),
            ApiResponse.formatInformations(apiResponse.informations),
        )
    }

    private static formatInformations(informations: Information[]): Information[] {
        return informations == null ? [] :
            informations.map(information => Information.from(information))
    }
}
